import { useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { TechniqueImpact } from "@l2r-front/l2r-proptypes"
import { useTheme } from "@l2r-front/l2r-ui"
import { getContrastTextColor } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { impacts } from "../../constants/impacts"

import * as Styled from "./TaskImpactBadge.styled"

export function TaskImpactBadge(props: TaskImpactBadgeProps): React.ReactNode {

    const {
        className,
        id,
        impact,
        variant = "filled",
        ...otherProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    const mainColor = impact !== undefined && impacts[impact]
        ? theme.palette[impacts[impact]?.backgroundColor]?.main
        : theme.palette["elevation/disabled"]?.main

    const badgeConfig = useMemo(() => {
        const constrastMainColor = getContrastTextColor(mainColor)

        return ({
            ...otherProps,
            backgroundColor: variant === "filled" ? mainColor : theme.palette.common.white,
            text: t(
                I18N_NAMESPACE,
                impact !== undefined && impacts[impact]?.acronyms
                    ? impacts[impact].acronyms
                    : "components.taskImpactBadge.noImpact"
            ),
            textColor: variant === "filled" ? constrastMainColor : mainColor,
        })
    }, [impact, mainColor, otherProps, t, theme, variant])

    return <Styled.ColoredBadge
        {...badgeConfig}
        borderColor={mainColor}
        className={className}
        id={id}
        textVariant="Desktop & Mobile/Heading/H4"
    />
}

type TaskImpactBadgeProps = {
    className?: string
    id?: string
    impact?: TechniqueImpact
    variant?: "filled" | "outlined"
}
